import { AfterViewChecked, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[missingProperty]',
})
export class MissingPropertyDirective implements AfterViewChecked {
    private domElement: HTMLElement;
    private fallbackSpan: HTMLElement | null = null;
    private fallbackApplied = false;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.domElement = el.nativeElement;
    }

    ngAfterViewChecked() {
        const hasContent = this.hasRealContent();

        if (hasContent && this.fallbackApplied) {
            this.removeFallback();
        } else if (!hasContent && !this.fallbackApplied) {
            this.applyFallback();
        }
    }

    private hasRealContent(): boolean {
        // Check original child nodes (skip our fallback span)
        for (let i = 0; i < this.domElement.childNodes.length; i++) {
            const node = this.domElement.childNodes[i];
            if (node === this.fallbackSpan) continue;
            if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim().length > 0) return true;
            if (node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).textContent?.trim().length > 0) return true;
        }
        return false;
    }

    private applyFallback() {
        this.fallbackApplied = true;
        this.renderer.addClass(this.domElement, 'dato-non-disponibile');
        this.renderer.setStyle(this.domElement, 'border', 'none');

        this.fallbackSpan = this.renderer.createElement('span');
        const text = this.renderer.createText('(dato non disponibile)');
        this.renderer.appendChild(this.fallbackSpan, text);
        this.renderer.appendChild(this.domElement, this.fallbackSpan);
    }

    private removeFallback() {
        this.fallbackApplied = false;
        this.renderer.removeClass(this.domElement, 'dato-non-disponibile');
        this.renderer.removeStyle(this.domElement, 'border');

        if (this.fallbackSpan) {
            this.renderer.removeChild(this.domElement, this.fallbackSpan);
            this.fallbackSpan = null;
        }
    }
}
